import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import {  Button } from 'antd';
import '../card.css';
import axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import {Checkbox} from 'semantic-ui-react';
import Select from "react-select";
import { API_BASE_URL } from "../utils/endpoints";


var senders=[]
var countryOptions = []
var sender_option=[]
var value_option=[]
var value_options=[]
var selectedOption=[]
var array_send_sender=[]
class EditForm extends React.Component {

  state = {

        firstname:'',
        lastname:'',
        email:'',
        account_status:false,
        expiry:'',
        mobile_number:'',
        land_line:'',
        weight:'',
        selected:[],
        account_status_value:false,
        isArabic:false,
        userName:'',
        superOperator:false,
        selectedOption: [],
       
       };
       handleChangeMenu = selectedOption => {
        this.setState({ selectedOption });
        senders=selectedOption;
      };
  componentWillMount(){

   
    var token=reactLocalStorage.get('accessToken');
 
    var id=reactLocalStorage.get('id_user_edit');
  
     var apiBaseUrl =API_BASE_URL + "/core/user/rest/user/"+reactLocalStorage.get('id_user_edit')+"/findByUserId";
  
  
     var ip=API_BASE_URL;
     var s2 = "localhost:3000";
     var apiBaseUrl;
     if(ip.includes(s2))
     {
      apiBaseUrl =API_BASE_URL + "/core/user/rest/user/"+reactLocalStorage.get('id_user_edit')+"/findByUserId";  
     }
     else
     {
      apiBaseUrl = API_BASE_URL+"/core/user/rest/user/"+reactLocalStorage.get('id_user_edit')+"/findByUserId";
     }
  
     var headers = {'Content-Type': 'application/json', 'tokken' :token }
     axios.get(apiBaseUrl,{headers: headers})
         .then(res => {
          this.setState({ 
            firstname: res.data.result.firstName ,
            lastname :res.data.result.lastName,
            email :res.data.result.email,
            mobile_number :res.data.result.mobile_number,
            land_line :res.data.result.land_line,
            weight :res.data.result.weight,
            expiry:res.data.result.account_expiration,
            account_status_value:res.data.result.status,
            userName:res.data.result.userName
          });
         if(res.data.result.active ===true)
         {
           this.setState({account_status_value:true})
           document.getElementById("data_check").checked = true
         }
         else{
          this.setState({account_status_value:false})
          document.getElementById("data_check").checked = false
         }
         })
         var token=reactLocalStorage.get('accessToken');
         var ip=API_BASE_URL;
         var s2 = "localhost:3000";
         var apiBaseUrl;
         if(ip.includes(s2))
         {
          apiBaseUrl =API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
          }
         else
         {
          apiBaseUrl = API_BASE_URL+"/core/user/rest/senderid/getSenderIds";  
         }
       
       
        
         var headers = {'Content-Type': 'application/json', 'token' :token }
       axios.get(apiBaseUrl,{headers: headers})
          .then(res => {
       
            if(res.data.result.sender_ids != undefined)
              {
                const senderidoption=res.data.result.sender_ids;
                var length=res.data.result.sender_ids.length;
                var i;
                const newArr = [];
                for(i=0;i<length;i++)
                {
                 var value_options=senderidoption[i].sender_id;
       
                 newArr.push({
                    label: value_options, 
                    value:senderidoption[i].id
                });
                  
                }
                this.setState({options_sender: res.data.result.sender_ids})
       
               
       
             
                
                countryOptions= newArr;
                this.setState({land_line:this.state.land_line})
               
             }
           
           })
       
        
  }
  back=()=>
  {
    window.location="addsubadmin";

  }
  
edit(){
  if(reactLocalStorage.get('role') ==='ROLE_OPERATOR')
  {
    
document.querySelector('.green_color').innerText='Create Admin'
  }
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/user/rest/senderid/getSenderIds?user_id="+reactLocalStorage.get('id_user_edit');
   }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/senderid/getSenderIds?user_id="+reactLocalStorage.get('id_user_edit');  
  }


 
  var headers = {'Content-Type': 'application/json', 'token' :token }
axios.get(apiBaseUrl,{headers: headers})
   .then(res => {

     if(res.data.result.sender_ids != undefined)
       {
         const senderidoption=res.data.result.sender_ids;
         var length=res.data.result.sender_ids.length;
         var i;
         const newArr = [];
         var object={};
         var value=this.state.firstname
         this.setState({firstname:value})
         for(i=0;i<length;i++)
         {
          
          
          object={label:senderidoption[i].sender_id,value:senderidoption[i].id};
          newArr.push(object)
        
         }
         this.setState({selectedOption:newArr})
         this.setState({firstname:this.state.firstname})
    
       }
    
    })
  var lang=i18n.language;
      if(lang ==="ar")
      {
        this.setState({isArabic:true})
      document.querySelector('.add_form').style = 'text-align:right;';       
      

      
      }
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
        this.setState({ superOperator: true });
      }
   

  
}

  handleChange = event => {
    this.setState({ firstname: event.target.value});

  }

  handleChangelname = event => {
    this.setState({ lastname: event.target.value});

  }
  handleChangepassword = event => {
    this.setState({ password: event.target.value});

  }
  handleChangemobile = event => {
    this.setState({ mobile_number: event.target.value});
  }

  handleChangeweight = event => {
    this.setState({ weight: event.target.value});

  }

  handleChangelandline = event => {
    this.setState({ land_line: event.target.value});

  }
  handleChangeexpiry = event => {
    this.setState({ expiry: event.target.value});

  }
  handleChangeaccount = event => {
    this.setState({ account_status: event.target.value});

  }
  
 
 
 

  handleChangeemail = event => {
    this.setState({ email: event.target.value});

  }
 
  handleChangeusername= event =>{
    this.setState({userName:event.target.value});
}

  handleSubmit = event => {
    event.preventDefault();
    var role_name;
    if(reactLocalStorage.get('role') ==='ROLE_OPERATOR')
    {
      role_name="ROLE_ADMIN"
    }
    if(reactLocalStorage.get('role') ==='ROLE_ADMIN')
    {
      role_name="ROLE_SUBADMIN"
    }
    var id_user=this.state.id_user;
    var token=reactLocalStorage.get('accessToken');
    array_send_sender=[]
    var i;
    for(i=0;i<senders.length;i++)
    {
      array_send_sender.push(senders[i].value)
    }
    
 var account=''
    if(document.getElementById("data_check").checked === true)
    {
     this.setState({account_status:true})
     account=true
    }
    else if(document.getElementById("data_check").checked === false)
    
    {
      
       this.setState({account_status:false})
       
       account='inactive'
    }
    const user = {
      'firstName': this.state.firstname,
      'lastName': this.state.lastname,
      'email': this.state.email,
      'role_name':role_name,
      'mobile_number':this.state.mobile_number,
      'land_line':this.state.land_line,
      'account_expiration':this.state.expiry,
      'userName':this.state.userName,
      'active':account,
      'weight':this.state.weight,
      'sender_ids':JSON.stringify(array_send_sender)
    };
    var data=user;
    var ip=API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if(ip.includes(s2))
    {
      apiBaseUrl =API_BASE_URL + "/core/user/rest/user/"+reactLocalStorage.get('id_user_edit')+"/updateUser";     
    }
    else
    {
     apiBaseUrl = API_BASE_URL+"/core/user/rest/user/"+reactLocalStorage.get('id_user_edit')+"/updateUser";
    }


    var headers = {
     'Content-Type': 'application/json',
      'tokken' :token
      }
    axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
    {

    if(response.status === 200)
    {
       if(response.data.status === 'success')
       {
       window.location="addsubadmin";
       }
       window.location="addsubadmin";

    }
    else if(response.status === 204){
    console.log("Something wrong");

    }
    else{
    console.log("Something wrong");

    }
    })
    .catch(function (error) {
    console.log(error);
    });
  }
  onChangesenderid=(event)=> {

    senders=event
   }
   enable=(event)=>{
     if(this.state.account_status_value === false)
     {
       this.setState({account_status_value:true})
       document.getElementById("data_check").checked = true;
     }
     else if (this.state.account_status_value === true){
      this.setState({account_status_value:false})
      document.getElementById("data_check").checked = false;
     }
   }


render() {
  const { selectedOption } = this.state;

  return (
    <div className="big_div">
          <Menutest/>
          <div className="actionMenu">
    <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit}>
                {this.state.superOperator ? (
                           <p className="h4 text-center py-4 text_style green_color"> {i18n.t('Edit_Admin.label')}</p>
                          ) : (
                            <p className="h4 text-center py-4 text_style green_color"> {i18n.t('Edit_Sub_Admin.label')}</p>

                          )}
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('First_Name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="firstName"
                  onChange={this.handleChange}
                  placeholder={this.state.firstname}
                  defaultValue={this.state.firstname}

                />
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('Family_Name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="lname"
                  onChange={this.handleChangelname}
                  placeholder={this.state.lastname}
                  defaultValue={this.state.lastname}

                />
                <br />

                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                 
                  {i18n.t('User_name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="lname"
                  disabled
                  onChange={this.handleChangeusername}
                  placeholder={this.state.userName}
                  defaultValue={this.state.userName}
                />
                <br />

                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('Email.label')}
                </label>
                <input
                  type="email"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangeemail}
                  placeholder={this.state.email}
                  defaultValue={this.state.email}
                />
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('expiry_date.label')}
                </label>
                <input
                  type="date"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="birthday"
                  onChange={this.handleChangeexpiry}
                  placeholder={this.state.expiry}
                  defaultValue={this.state.expiry}
                />
                <br />

                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('Email.label')}
                </label>
                <input
                  type="email"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangeemail}
                  placeholder={this.state.email}
                  defaultValue={this.state.email}
                />
                <br />

                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('Mobile_Number.label')}
                </label>
                <input
                  type="number"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangemobile}
                  placeholder={this.state.mobile_number}
                  defaultValue={this.state.mobile_number}
                />
                <br />


                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('landline.label')}
                </label>
                <input
                  type="number"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangelandline}
                  placeholder={this.state.land_line}
                  defaultValue={this.state.land_line}
                />
                <br />

                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('weight.label')}
                </label>
                <input
                  type="number"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangeweight}
                  placeholder={this.state.weight}
                  defaultValue={this.state.weight}
                />
                <br />
                <label
                            htmlFor="defaultFormCardNameEx"
                            className="grey-text font-weight-light"
                        >
                        
                        {i18n.t('Sender_ID.label')}
                        </label>
                        <Select
       isMulti
       placeholder='Select ...'
       fluid
       search
       selection
        value={selectedOption}
        onChange={this.handleChangeMenu}
        options={countryOptions}
        className="sender_value"
        id="sender_select"
      />
                      
                        
                     
                    <br/>
                <Checkbox label= {i18n.t('active.label')} style={{width:'20%'}} onClick={this.enable} id='data_check' style={{ width: '34%',float:this.state.isArabic?'right':''}}
                 checked={this.state.account_status_value} />
            

                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_green">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_green">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>

                  </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div> </div> 
    
    </div>
  );
}
}
const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (EditForm);
